module.exports = __webpack_public_path__ + "img/Priest-bloodelf-f-70.87614017.gif";